export const contentManagementRoutes = [
  {
    path: '/admin/content-management',
    name: 'content-management-grid',
    meta: { layout: 'dashboard' },
    component: () => import(/* webpackChunkName: "house-floors" */ './ContentManagementView.vue'),
  },
];
